// NavStore.ts
import { makeAutoObservable, action, toJS } from "mobx";
import { v4 as uuid } from "uuid";
interface IbreadList {
    title: string
    key?: string
    handleClick?: () => void
    id?: number
}
class Bread {
    breadList: IbreadList[] = []
    constructor() {
        makeAutoObservable(this);
    }

    addBreadList = action(async (item) => {
        const newArr = [...this.breadList]
        if (item?.length) {
            newArr.push(...item.map(v => ({ ...v, key: uuid() })))
        }
        else {
            newArr.push({ ...item, key: uuid() })
        }

        this.breadList = newArr
    });
    deleteBreadList = action(async (key) => {
        const newArr = [...this.breadList]
        if (newArr.length === 1) {
            this.breadList = []
            return
        }
        this.breadList = newArr.slice(0, newArr.findIndex(v => v.key === key) + Number(newArr.findIndex(v => v.key === key) !== 0)).filter(v => v.title !== '创作空间')
    });
    clearBreadList = action(async () => {
        this.breadList = []
    });
}

const BreadStore = new Bread();

export default BreadStore;
